module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"standard":"Standard","manager":"Manager","admin":"Admin","unknown":"Unknown"}}')
  delete Component.options._Ctor
}
